/**
 * SERPROMAQ - Módulo Interactivo de la Sección Nosotros & Carrusel de Cultura Humana
 * Maneja el selector de pestañas (Misión/Visión, Política Integral, Valores)
 * y el carrusel de fotografías del equipo con auto-play, miniaturas y navegación táctil/click.
 */

export function initAboutModule() {
  // 1. Selector de Pestañas Interactivas (Nosotros Tabs)
  const tabButtons = document.querySelectorAll('.about-nav-tab');
  const tabPanels = document.querySelectorAll('.about-tab-panel');

  if (tabButtons.length && tabPanels.length) {
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const targetTab = button.getAttribute('data-tab');

        // Actualizar estado de los botones
        tabButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        // Actualizar paneles con animación de entrada
        tabPanels.forEach(panel => {
          if (panel.id === `tab-${targetTab}`) {
            panel.classList.add('active');
            const animElements = panel.querySelectorAll('.about-card-interactive, .hseq-pill-item, .valor-chip-card');
            animElements.forEach((el, idx) => {
              el.style.animation = 'none';
              void el.offsetWidth; // Forzar reflow
              el.style.animation = `fadeInUp 0.45s cubic-bezier(0.16, 1, 0.3, 1) ${idx * 0.06}s forwards`;
            });
          } else {
            panel.classList.remove('active');
          }
        });
      });
    });
  }

  // 2. Carrusel Multimedia de Cultura, Compañerismo y Dinámicas SERPROMAQ
  const carouselContainer = document.getElementById('aboutTeamCarousel');
  if (!carouselContainer) return;

  const slides = carouselContainer.querySelectorAll('.about-slide');
  const dotsContainer = document.getElementById('aboutCarouselDots');
  const thumbsContainer = document.getElementById('aboutCarouselThumbs');
  const prevBtn = document.getElementById('aboutPrevBtn');
  const nextBtn = document.getElementById('aboutNextBtn');
  const currentCounter = document.getElementById('aboutCurrentSlide');
  const totalCounter = document.getElementById('aboutTotalSlides');
  const progressBar = document.getElementById('aboutCarouselProgress');
  const infoCardContainer = document.getElementById('aboutSlideInfoCard');
  const infoItems = infoCardContainer ? infoCardContainer.querySelectorAll('.about-info-item') : [];

  if (!slides.length) return;

  const aboutSection = document.getElementById('nosotros');
  let currentSlideIndex = 0;
  const totalSlides = slides.length;
  let autoPlayTimer = null;
  const AUTO_PLAY_INTERVAL = 4000; // 4 segundos por slide
  let isHovered = false;
  let isAboutSectionVisible = false;

  if (totalCounter) {
    totalCounter.textContent = totalSlides < 10 ? `0${totalSlides}` : `${totalSlides}`;
  }

  // Renderizar Dots si existe el contenedor
  if (dotsContainer) {
    dotsContainer.innerHTML = '';
    slides.forEach((_, idx) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `about-carousel-dot ${idx === 0 ? 'active' : ''}`;
      dot.setAttribute('aria-label', `Ir a foto ${idx + 1}`);
      dot.addEventListener('click', () => {
        goToSlide(idx);
        restartAutoPlay();
      });
      dotsContainer.appendChild(dot);
    });
  }

  // Miniaturas interactivas (thumbnails)
  const thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.about-thumb-btn') : [];
  thumbs.forEach((thumb, idx) => {
    thumb.addEventListener('click', () => {
      goToSlide(idx);
      restartAutoPlay();
    });
  });

  const VIDEO_INDEX = slides.length - 1;
  const teamVideo = document.getElementById('aboutTeamVideo');
  const audioToggleBtn = document.getElementById('aboutAudioToggle');
  const audioLabel = document.getElementById('aboutAudioLabel');

  function setAudioState(isMuted) {
    if (!teamVideo) return;
    teamVideo.muted = isMuted;
    if (audioToggleBtn) {
      audioToggleBtn.classList.toggle('muted', isMuted);
      const icon = audioToggleBtn.querySelector('i');
      if (icon) {
        icon.className = isMuted ? 'fa-solid fa-volume-xmark' : 'fa-solid fa-volume-high';
      }
    }
    if (audioLabel) {
      audioLabel.textContent = isMuted ? 'Mudo' : 'Sonido ON';
    }
  }

  if (audioToggleBtn && teamVideo) {
    audioToggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      setAudioState(!teamVideo.muted);
    });
  }

  function updateSlide(index) {
    slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });

    // Actualizar dots
    if (dotsContainer) {
      const dots = dotsContainer.querySelectorAll('.about-carousel-dot');
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }

    // Actualizar thumbnails
    if (thumbs.length) {
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === index);
      });
    }

    // Actualizar recuadro inferior de texto descriptivo
    if (infoItems.length) {
      infoItems.forEach((item, i) => {
        item.classList.toggle('active', i === index);
      });
    }

    // Actualizar contador numérico
    if (currentCounter) {
      currentCounter.textContent = index + 1 < 10 ? `0${index + 1}` : `${index + 1}`;
    }

    // Comportamiento especial para el Video (Slide final)
    if (index === VIDEO_INDEX && teamVideo) {
      stopAutoPlay();
      teamVideo.currentTime = 0;

      // Solo reproducir si la sección nosotros está visible actualmente en pantalla
      if (isAboutSectionVisible) {
        setAudioState(false);
        const playPromise = teamVideo.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Si el navegador requiere interacción previa, reproducir silenciado
            setAudioState(true);
            teamVideo.play().catch(() => {});
          });
        }
      } else {
        teamVideo.pause();
      }

      // Al terminar el video de 50s, volver automáticamente a la foto 1 e iniciar ciclo
      teamVideo.onended = () => {
        goToSlide(0);
        if (isAboutSectionVisible) {
          restartAutoPlay();
        }
      };

      // Sincronizar barra de progreso con duración real del video
      teamVideo.ontimeupdate = () => {
        if (progressBar && teamVideo.duration) {
          const pct = (teamVideo.currentTime / teamVideo.duration) * 100;
          progressBar.style.animation = 'none';
          progressBar.style.width = `${pct}%`;
        }
      };
    } else {
      // Slides normales de fotos
      if (teamVideo) {
        teamVideo.pause();
        teamVideo.currentTime = 0;
        teamVideo.ontimeupdate = null;
        teamVideo.onended = null;
      }

      if (progressBar) {
        progressBar.style.width = '0%';
        progressBar.style.animation = 'none';
        void progressBar.offsetWidth;
        if (!isHovered) {
          progressBar.style.animation = `aboutProgressAnim ${AUTO_PLAY_INTERVAL}ms linear infinite`;
        }
      }
    }
  }

  function goToSlide(index) {
    if (index < 0) {
      currentSlideIndex = totalSlides - 1;
    } else if (index >= totalSlides) {
      currentSlideIndex = 0;
    } else {
      currentSlideIndex = index;
    }
    updateSlide(currentSlideIndex);
  }

  function nextSlide() {
    goToSlide(currentSlideIndex + 1);
  }

  function prevSlide() {
    goToSlide(currentSlideIndex - 1);
  }

  // Botones anterior / siguiente
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      if (currentSlideIndex !== VIDEO_INDEX) {
        restartAutoPlay();
      }
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      if (currentSlideIndex !== VIDEO_INDEX) {
        restartAutoPlay();
      }
    });
  }

  // Auto-play continuo
  function startAutoPlay() {
    stopAutoPlay();
    if (currentSlideIndex === VIDEO_INDEX) return; // No auto-rotar mientras corre el video

    if (progressBar) {
      progressBar.style.animation = `aboutProgressAnim ${AUTO_PLAY_INTERVAL}ms linear infinite`;
    }
    autoPlayTimer = setInterval(() => {
      if (!isHovered) {
        nextSlide();
      }
    }, AUTO_PLAY_INTERVAL);
  }

  function stopAutoPlay() {
    if (autoPlayTimer) {
      clearInterval(autoPlayTimer);
      autoPlayTimer = null;
    }
    if (progressBar && currentSlideIndex !== VIDEO_INDEX) {
      progressBar.style.animationPlayState = 'paused';
    }
  }

  function restartAutoPlay() {
    stopAutoPlay();
    startAutoPlay();
  }

  // Pausar al pasar el mouse por encima para apreciar las fotos
  carouselContainer.addEventListener('mouseenter', () => {
    isHovered = true;
    if (progressBar) progressBar.style.animationPlayState = 'paused';
  });

  carouselContainer.addEventListener('mouseleave', () => {
    isHovered = false;
    if (progressBar) progressBar.style.animationPlayState = 'running';
  });

  // Soporte de gestos táctiles (Swipe en móviles)
  let touchStartX = 0;
  let touchEndX = 0;

  carouselContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });

  carouselContainer.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].screenX;
    const diff = touchStartX - touchEndX;
    if (Math.abs(diff) > 45) {
      if (diff > 0) {
        nextSlide(); // Swipe izquierda -> siguiente
      } else {
        prevSlide(); // Swipe derecha -> anterior
      }
      restartAutoPlay();
    }
  }, { passive: true });

  // IntersectionObserver: Solo reproducir video y carrusel cuando la sección Nosotros esté en pantalla
  if (aboutSection && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        isAboutSectionVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;

        if (isAboutSectionVisible) {
          // Entró a la sección Nosotros
          if (currentSlideIndex === VIDEO_INDEX && teamVideo) {
            setAudioState(false);
            const playPromise = teamVideo.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                setAudioState(true);
                teamVideo.play().catch(() => {});
              });
            }
          } else {
            restartAutoPlay();
          }
        } else {
          // Salió de la sección Nosotros: Pausar inmediatamente video y silenciar
          stopAutoPlay();
          if (teamVideo) {
            teamVideo.pause();
            setAudioState(true);
          }
        }
      });
    }, { threshold: [0, 0.25, 0.5] });

    observer.observe(aboutSection);
  } else {
    isAboutSectionVisible = true;
    startAutoPlay();
  }

  // Inicializar estado del carrusel
  updateSlide(0);
}
